'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STYLE_PROP = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Inlined Style property


var STYLE_PROP = exports.STYLE_PROP = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object, _propTypes2.default.array]);